export var replaceUrlSearchParams = function (searchParams) {
    var uri = "" + window.location.origin + window.location.pathname;
    window.history.replaceState(null, "", "" + uri + (typeof searchParams === "string" ? "" : "?") + searchParams.toString());
};
